import { createContext, useContext } from 'react';

const AdminTenantContext = createContext(undefined);

function useAdminTenantContext() {
  const context = useContext(AdminTenantContext);

  if (context === undefined) {
    throw new Error(
      'useAdminTenantContext must be used within AdminTenantProvider'
    );
  }

  return context;
}

export { AdminTenantContext, useAdminTenantContext };
